export default __webpack_public_path__ + "static/media/climateDataHIstorySvg.a27a8129.svg";